import React from 'react';
import Image from './Image';
import { paintRBGImagePropTypes, paintRBGImageDefaultProps } from '../propTypes';

/**
 * PaintRGBImage component renders a color swatch with a background color
 * based on the provided RGB values and overlays a brand image if available.
 *
 * @param {Object} props
 * @param {Object} props.asset - The asset object containing rgb and brandLogo.
 * @param {string} [props.alt] - The alt text for the brand image.
 * @returns {JSX.Element|null}
 */
const PaintRGBImage = ({ asset, alt }) => {
  if (!asset) return null;
  const rgb = asset?.rgb;
  return (
    <div
      className="w-full h-auto aspect-square max-w-full flex items-end"
      style={{
        backgroundColor: `rgb(${rgb?.red},${rgb?.green},${rgb?.blue})`
      }}
    >
      <Image
        alt={alt}
        src={asset?.brandLogo}
      />
    </div>
  );
};

PaintRGBImage.propTypes = paintRBGImagePropTypes;
PaintRGBImage.defaultProps = paintRBGImageDefaultProps;

export default PaintRGBImage;